// @flow
import * as React from 'react';
import { pure } from 'recompose';
import isTouchDevice from 'is-touch-device';
import { OverlayTrigger, Tooltip } from 'angieslist-react-components';

type Props = {
  id: string,
  icon: string,
  label: string,
  onClick: Function,
  additionalClasses: string,
};

const usingTouchDevice = isTouchDevice();

const createButtonWithTooltipComponent = ({
  id, icon, label, onClick, additionalClasses,
}: Props): React.Node => (
  <Choose>
    <When condition={usingTouchDevice}>
      <button
        type="button"
        className={`mapboxgl-ctrl-icon ${additionalClasses}`}
        id={`${id}-mobile`}
        aria-label={label}
        onClick={onClick}
      >
        <i className={`icon icon-${icon} icon-2x`} />
      </button>
    </When>
    <Otherwise>
      <OverlayTrigger
        placement="left"
        overlay={
          <Tooltip id={`tooltip-${id}`}>
            <strong>{label}</strong>
          </Tooltip>
        }
      >
        <button
          type="button"
          className={`mapboxgl-ctrl-icon ${additionalClasses}`}
          id={`${id}-desktop`}
          aria-label={label}
          onClick={onClick}
        >
          <i className={`icon icon-${icon} icon-2x`} />
        </button>
      </OverlayTrigger>
    </Otherwise>
  </Choose>
);

export default (pure(createButtonWithTooltipComponent): any);



// WEBPACK FOOTER //
// ./src/app/browser/service-areas/ButtonWithTooltip.js